import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { FetchUserAccount } from "../../../../../actions/UserAccount";
import ErrorPage from "../../../../../components/shared/errorPage/ErrorPage";
import Loader from "../../../../../components/shared/loader/Loader";
import { LOCALSESSIONDATAKEYS, SIGNUPTYPE } from "../../../../../constants/AppConstants";
import { WebCustomerRoutePaths, routePath } from "../../../../../constants/Routes";
import { getLocalSessionData } from "../../../../../utils/Authentication/handleUserSession";
import { UserEnrolledDevicesServiceInit } from "../../../../../store/UserEnrolledDevices/UserEnrolledDevicesSlice";

const ProcessUserAccount = (props) => {
    const BOCUserId = props.location?.state?.BOCUserId;
    const dispatch = useDispatch();
    const UserAccountResult = useSelector((state) => state.UserAccount);
    const [callUserAccount, setCallUserAccount] = useState(true);
    const {
        userDeviceList_error,
        userDeviceList_loading,
        userDeviceList_success
    } = useSelector(state => state.ROOTREDUCER_RTK.GetUserEnrolledDevicesService);

    useEffect(() => {
        if (!userDeviceList_loading && !userDeviceList_success) {
            dispatch(UserEnrolledDevicesServiceInit());
        }
    }, [dispatch, userDeviceList_loading, userDeviceList_success])

    const AZURE_AD_B2C_UID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
    const SignupType = getLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE);

    /** Display error page when GetUserEnrolledDevices fails */
    if (userDeviceList_error) {
        return <ErrorPage errorInfo={userDeviceList_error}></ErrorPage>
    }

    /** Call GetUserAccount API only after GetUserEnrolledDevices APi is successful */
    if (callUserAccount && userDeviceList_success) {
        dispatch(FetchUserAccount(AZURE_AD_B2C_UID, BOCUserId, null, SignupType));
        setCallUserAccount(false);
    }

    /** Display error page when GetUserAccount fails */
    if (UserAccountResult.error) {
        return <ErrorPage errorInfo={UserAccountResult.error}></ErrorPage>
    }

    /** Redirect to respective web enrollment journey if GetUserAccount API is successful */
    if (UserAccountResult.success) {
        return (SignupType === SIGNUPTYPE.BROTHER_PLUS)
            ? <Redirect to={routePath.CONNECT_DEVICE_DASHBOARD} />
            : <Redirect to={WebCustomerRoutePaths.ACCOUNT} />
    }

    return (
        <Loader></Loader>
    )
}

export default ProcessUserAccount;